module.exports = __webpack_public_path__ + "2782f40175b399ce3b5215b1dab1c254.MP3";